export default class LeadgenModal {

    constructor(save_url, save_and_back_url) {
        this.save_url = save_url;
        this.save_and_back_url = save_and_back_url;
    }

    open_modal(modal_id) {
        $(modal_id).modal('show')
    }

    get_modal_form_input(form, input_identifier) {
        return form.find(input_identifier);
    }

    change_modal_container_content(modal_container, new_content) {
        modal_container.html(new_content)
    }

    get_modal_component(modal, input_identifier) {
        return modal.find(input_identifier);
    }

    check_and_set_delay_on_open(modal_id, seconds) {
        let $this = this;
        let delay_seconds = $(modal_id).data('delay_on_open')
        delay_seconds ? parseInt(delay_seconds) : null;

        if (delay_seconds) {
            setTimeout(function() {
                $this.open_modal(modal_id)
            }, seconds * 1000)

            return;
        }

        this.open_modal(modal_id);
    }

    close_modal(modal) {
        modal.modal('hide')
    }

    get_modal(modal_id) {
        return $(modal_id)
    }

    modal_completed(modal_id) {
        this.close_modal(modal_id)
    }

    append_input_to_form(form, type, name, value) {
        let input = form.find("input[name='"+name+"']");
        if (input.val()) {
            input.attr('value', value)

            return;
        }

        var modal_input = document.createElement("input");

        modal_input.setAttribute("type", type);
        modal_input.setAttribute("name", name);
        modal_input.setAttribute("value", value);

        form.append(modal_input);
    }

    append_hidden_inputs_to_form(form, custom_inputs = []) {
        custom_inputs.forEach(item => {
            this.append_input_to_form(form, 'hidden', item['name'], item['value'])
        })
    }

    get_modal_data_to_url(modal, modal_step_container, custom_inputs = []) {
        let modal_name = this.get_modal_name(modal)
        let form = modal_step_container.find('form');

        this.append_hidden_inputs_to_form(form, custom_inputs)
        this.append_input_to_form(form, 'hidden', 'modal', modal_name)

        return form.serialize()
    }

    get_step_container_form(modal_step_container) {
        return modal_step_container.find('form');
    }

    get_form_step_name(form) {
        return form.find('input[name="step"]').val();
    }

    get_modal_name(modal) {
        return modal.data('modal')
    }

    enable_button(button) {
        button.attr('disabled', false);
    }

    disable_button(button) {
        button.attr('disabled', 1);
    }

    send_form(url, data, done_callback, fail_callback) {
        $.ajax({
            url: url,
            data: data,
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response, status, xhr) {
            done_callback && typeof done_callback === 'function' ? done_callback(response) : ''
        }).fail(function (error) {
            fail_callback && typeof fail_callback === 'function' ? fail_callback(error) : ''
        })
    }
}
